module.exports = __webpack_public_path__ + "img/top-bar.cd92cad1.png";